<div id="wrapper" [ngClass]="{'nav-collapsed menu-collapsed' : getSideBarState()}">
    <app-sidebar *ngIf="!isEmbeddedMode"></app-sidebar>
    <app-navbar *ngIf="!isEmbeddedMode"></app-navbar>
    <div class="clearfix"></div>
    <div class="content-wrapper">
        <div class="container-fluid">
            <router-outlet></router-outlet>
            <div *ngIf="!isEmbeddedMode" class="overlay" (click)="toggleSidebar()" [ngClass]="{'show' : getSideBarState()}"></div>
        </div>
    </div>
    <app-footer *ngIf="!isEmbeddedMode"></app-footer>
    <!-- <app-color-switcher></app-color-switcher> -->
</div>